import { render, staticRenderFns } from "./ClassesDisplay.vue?vue&type=template&id=2651f316&scoped=true&"
import script from "./ClassesDisplay.vue?vue&type=script&lang=js&"
export * from "./ClassesDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2651f316",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2651f316')) {
      api.createRecord('2651f316', component.options)
    } else {
      api.reload('2651f316', component.options)
    }
    module.hot.accept("./ClassesDisplay.vue?vue&type=template&id=2651f316&scoped=true&", function () {
      api.rerender('2651f316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/classes/ClassesDisplay.vue"
export default component.exports